import React, { useEffect, useState } from "react";
import { Button, Form, Space, Row, Checkbox, Col } from "antd";
import { InputText, trans, InputDate } from "@comps/components"
import { Const } from "../../constants";
import { createSelectList } from '@comps/commonFunctions';
import { attendancePlannerPolicyDependencies } from "../policyDependencyConfig";
import PolicySelectWithActions from "./PolicySelectWithActions";

const CreateStepOne = (props) => {
  const langKey = Const["attendancePolicyPlanner"].lngKey
  const formName = "createAttendancePolicyPlanner";
  //========================use states start========================
  const [policyOptions, setPolicyOptions] = useState({})
  const [form] = Form.useForm();
  const watchedValues = Form.useWatch([], form) || {};
  //=======================================
  useEffect(() => {
    setData();
    // eslint-disable-next-line
  }, [props]);

  //set props data
  //=================Submit First Step 1==============================================
  const setData = () => {
    if (!props.relatedData) {
      return;
    }

    const nextOptions = {};
    attendancePlannerPolicyDependencies.forEach((dependency) => {
      nextOptions[dependency.field] = createSelectList(props.relatedData[dependency.relatedListKey] || []);
    });
    setPolicyOptions(nextOptions);
  }

  //=====================On Submit Second Step===========================
  const onSubmitFirstStep = (data) => {
    props.response(data);
  }
  //=====================Unassign a policy from this planner===========================
  const onClearPolicy = (field) => {
    form.setFieldsValue({ [field]: null });
  }
  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------
  return (
    <>
      <Form
        { ...formLayout }
        name={ formName }
        onFinish={ onSubmitFirstStep }
        initialValues={ props.initialValues ? props.initialValues : null }
        form={ form }
      >
        <Row gutter={ 30 }>
          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="name" rules={ rules.name } label={ trans(`${langKey}.name`) }
              className="da-mb-16"

            >
              <InputText placeholder={ trans(`${langKey}.name`) } />
            </Form.Item>
          </Col>

          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="date" rules={ rules.date } label={ trans(`${langKey}.date`) }
              className="da-mb-16"

            >
              <InputDate />
            </Form.Item>
          </Col>

          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="for_all" rules={ rules.for_all } label={ trans(`${langKey}.for_all`) }
              className="da-mb-10"
              valuePropName="checked"
            >
              <Checkbox />
            </Form.Item>
          </Col>
          { attendancePlannerPolicyDependencies.map((dependency) => (
            <Col key={ dependency.key } lg={ 12 } sm={ 24 } xs={ 24 }>
              <PolicySelectWithActions
                name={ dependency.field }
                label={ trans(`${langKey}.${dependency.field}`) }
                placeholder={ trans(`${langKey}.${dependency.field}`) }
                options={ policyOptions[dependency.field] || [] }
                buttonLabel={ dependency.label }
                selectedValue={ watchedValues[dependency.field] }
                onCreate={ () => props.onCreateDependency(dependency.key) }
                onEdit={ () => props.onEditDependency(dependency.key, watchedValues[dependency.field]) }
                onDelete={ () => onClearPolicy(dependency.field) }
              />
            </Col>
          )) }
        </Row>

        <Row justify="end">
          <Space>
            <Button className="button-next" type="primary" htmlType="submit">
              { props.submitLabel || "Next" }
            </Button>
            {/* <CancelButton key="close_button" onClick={ () => props.onCancel(false) } /> */ }
          </Space>
        </Row>
      </Form>
    </>
  )
}
export default CreateStepOne
const rules = {
  date: [
    { required: true, message: 'Required' },
  ],
  name: [
    { required: true, message: 'Required' },
  ],
};
const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}
